<script setup lang="ts">
import { useTopicsQuery } from '~~/src/composables/query/topic/useTopicsQuery'

interface IProps {
  topicId: number
  redirect?: boolean
  hideEmptyTopic?: boolean
}

const props = withDefaults(
  defineProps<IProps>(),
  {
    redirect: true,
  },
)
const { topicId, redirect } = toRefs(props)
const filters = useFilters()
const { data: topics } = useTopicsQuery({
  query: {},
})
const topic = computed(() => {
  if (!topics.value)
    return null

  const typeId = filters.value.type_ids?.[0] || 1
  const isTextFilter = typeId === PROMPT_TYPES.Text
  return topics.value
    .filter((topic) => {
      if (!props.hideEmptyTopic)
        return true
      return isTextFilter ? topic.nTextPrompts > 0 : topic.nVisualPrompts > 0
    })
    .find(topic => topic.id === topicId.value)
})

const topicDisplay = computed(() => `${topic.value?.emoji} ${topic.value?.name}`)
const topicDescription = computed(() => `Explore ${topic.value?.name} prompts and content`)
</script>

<template>
  <NuxtLink
    v-if="topic"
    :to="redirect ? `/topic/${topic.url}` : ''"
    :aria-label="topicDescription"
    :title="topicDescription"
  >
    <div
      flex items-center justify-center gap="2px"
      px-3 h-7 rounded-full
      text-darker-gray bg-gray-lighter hover:bg-soft-gray
      transition-colors
      :data-color="`#${topic?.color}`"
      class="topic-colored"
      :style="{
        cursor: redirect ? 'pointer' : 'inherit',
      }"
    >
      <Text variant="caption" :aria-label="`Topic: ${topic.name}`">
        {{ topicDisplay }}
      </Text>
    </div>
  </NuxtLink>
</template>
